// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60dc1f95","455":"35126ad0","977":"314d3237"}[chunkId] + ".chunk.js";
};